import { render, staticRenderFns } from "./AmalgamationOfficeAndRecords.vue?vue&type=template&id=15384762&scoped=true&"
import script from "./AmalgamationOfficeAndRecords.vue?vue&type=script&lang=js&"
export * from "./AmalgamationOfficeAndRecords.vue?vue&type=script&lang=js&"
import style0 from "./AmalgamationOfficeAndRecords.vue?vue&type=style&index=0&id=15384762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15384762",
  null
  
)

export default component.exports